import _PhotoIcon from "@adsk/alloy-react-icon/es/lib/PhotoIcon";
import _styled, { default as _styled2 } from "styled-components";
const _excluded = ["style", "className", "alt", "src", "onError", "onLoad", "renderError"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const Image = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      alt,
      src,
      onError,
      onLoad,
      renderError = () => /*#__PURE__*/React.createElement(_PhotoIcon, {
        style: {
          color: theme.tokens.colors.icon.inactive.value
        }
      })
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [error, setError] = useState(false); // Whether image failed to load
  const [loaded, setLoaded] = useState(false); // Whether image loaded successfully
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    "data-testid": !error ? 'Tile__image' : 'Tile__image-placeholder',
    $_css: [{
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }]
  }, !error && /*#__PURE__*/React.createElement(_StyledImg, _extends({
    ref: ref,
    className: className,
    alt: alt,
    src: src
  }, props, {
    onError: event => {
      setError(true);
      onError === null || onError === void 0 ? void 0 : onError(event);
    },
    onLoad: event => {
      setLoaded(true);
      onLoad === null || onLoad === void 0 ? void 0 : onLoad(event);
    },
    $_css2: [_objectSpread({
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }, !loaded && {
      display: 'none'
    }), style]
  })), error && renderError());
});
Image.displayName = 'Image';
Image.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The alt text for the image */
  alt: PropTypes.string,
  /** The image URL */
  src: PropTypes.string,
  /** Function that will be executed if an error is encountered when loading image */
  renderError: PropTypes.func,
  /** Function that will be execute on image failed to load */
  onError: PropTypes.func,
  /** Function that will be execute on image load successfully*/
  onLoad: PropTypes.func
};
export default Image;
var _StyledDiv = _styled("div")`${p => p.$_css}`;
var _StyledImg = _styled2("img").withConfig({
  displayName: "Image___StyledImg",
  componentId: "sc-nkghwd-0"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=Image.js.map